export { default as PButton } from "./PButton.vue";

